// extracted by mini-css-extract-plugin
export var container = "_s4-0";
export var dotAnimation = "_s4-2";
export var dotsLoading = "_s4-1";